// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3I2l4","resendInfoText":"OnGoingPaymentBox_resendInfoText__1vzCV"};